import { Reveal } from "@components/ui";
import dcdLogo from "@assets/images/Directorate-General-of-Dubai-Civil-Defence-logo-1@2x.png";
import esmaLogo from "@assets/images/Directorate-General-of-Dubai-Civil-Defence-logo-11@2x.png";
import verifyIcon from "@assets/images/vuesax-bold-verify.svg";
import shieldIcon from "@assets/images/vuesax-bold-shield-tick.svg";

export function CertificationBadgeSection() {
  return (
    <section className="w-full bg-white overflow-hidden px-5 md:px-10 lg:px-[180px] py-10 md:py-14 lg:py-[100px]">
      <div className="w-full max-w-[1368px] mx-auto font-albert-sans">
        <Reveal direction="up">
          <div className="group w-full rounded-[16px] bg-[#eaeaea] overflow-hidden flex flex-col relative border border-transparent hover:border-[#e8e9ed] hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all duration-300">
            {/* Gradient Accent Bar */}
            <div className="w-full h-1.5 bg-gradient-to-r from-[#122d63] via-[#269d0e] to-[#f24d2b]" />

            <div className="flex flex-col lg:flex-row items-center justify-between gap-8 md:gap-10 py-8 px-6 md:py-10 md:px-10 lg:py-[60px] lg:pl-16 lg:pr-[90px]">
              {/* Text */}
              <div className="flex flex-col items-start gap-3 max-w-[753px]">
                {/* Pill Badge */}
                <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-[#122d63]/8 text-[#122d63] text-[13px] md:text-[15px] font-semibold tracking-[-0.04em] uppercase">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.91 11.12C20.91 16.01 17.36 20.59 12.51 21.93C12.18 22.02 11.82 22.02 11.49 21.93C6.64 20.59 3.09 16.01 3.09 11.12V6.73C3.09 5.91 3.71 4.98 4.48 4.67L10.05 2.39C11.3 1.88 12.71 1.88 13.96 2.39L19.53 4.67C20.29 4.98 20.92 5.91 20.92 6.73L20.91 11.12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9.05 11.87L10.66 13.48L14.96 9.18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Certified
                </span>
                <h2 className="text-[28px] md:text-[40px] lg:text-[48px] font-semibold tracking-[-0.04em] text-[#122d63] leading-[1.1]">
                  Licensed, Inspected, and Approved
                </h2>
                <p className="text-[14px] md:text-[18px] lg:text-[22px] tracking-[-0.04em] text-[#62636c] leading-[1.4]">
                  All GAZ installations are certified by Dubai Civil Defense
                  (DCD) and the Emirates Authority for Standardization and
                  Metrology (ESMA). We provide each client with a Safety
                  Certificate after successful inspection and pressure testing.
                </p>
              </div>

              {/* Certification Badges */}
              <div className="flex items-start gap-4 shrink-0">
                {/* ISO Badge */}
                <div className="flex items-center pt-0 lg:pb-[54px]">
                  <div className="w-[140px] h-[140px] md:w-[160px] md:h-[160px] lg:w-[180px] lg:h-[180px] rounded-full bg-white border border-white/70 overflow-hidden flex items-center justify-center relative transition-transform duration-300 group-hover:scale-105">
                    <img
                      src={dcdLogo}
                      alt="Dubai Civil Defence"
                      className="w-[80%] h-auto object-cover z-[1]"
                    />
                    <div className="absolute bottom-4 flex flex-col items-center gap-2">
                      <img src={verifyIcon} alt="" className="w-6 h-6" />
                      <span className="text-[14px] md:text-[16px] lg:text-[20px] font-semibold tracking-[-0.04em] text-[#595959] text-center leading-tight">
                        ISO 9003
                        <br />
                        Certified
                      </span>
                    </div>
                  </div>
                </div>

                {/* DCD Badge */}
                <div className="flex items-center pt-[54px] lg:pt-[54px]">
                  <div className="w-[140px] h-[140px] md:w-[160px] md:h-[160px] lg:w-[180px] lg:h-[180px] rounded-full bg-white border border-white/70 overflow-hidden flex items-center justify-center relative transition-transform duration-300 group-hover:scale-105">
                    <img
                      src={esmaLogo}
                      alt="ESMA"
                      className="w-[75%] h-auto object-cover z-[1]"
                    />
                    <div className="absolute bottom-4 flex flex-col items-center gap-2">
                      <img src={shieldIcon} alt="" className="w-6 h-6" />
                      <span className="text-[14px] md:text-[16px] lg:text-[20px] font-semibold tracking-[-0.04em] text-[#595959] text-center leading-tight">
                        DCD
                        <br />
                        Approved
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
